import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const AttwoodPage = () => <LocationTemplate suburbName="Attwood" suburbSlug="attwood" />;

export default AttwoodPage;
